<template >
    <page-base :taxpayerInfo="currentTaxpayer">
        <template slot="content">
            <b-alert variant="danger no-print" :show="showAlert">
                {{ alert }}
            </b-alert>
            <div>
                <z-report-heading v-if="report.type === 'REPORT_Z' || report.type === 'REPORT_X'" :taxpayerInfo="currentTaxpayer" :reportInfo="reportInfo" :report="report"/>
                <fiscal-period-report-heading v-if="report.type === 'FISCAL_PERIOD_REPORT' || report.type === 'FISCAL_PERIOD_REPORT_V2'" :taxpayerInfo="currentTaxpayer" :reportInfo="reportInfo" :report="report"/>
                <cashier-report-heading v-if="report.type === 'CASHIER_REPORT' || report.type === 'SECTION_REPORT'" :taxpayerInfo="currentTaxpayer" :reportInfo="reportInfo" :report="report"/>
                <b-card v-if="Object.keys(report).length">
                    <div class="text-right" style="padding: 0 0.75rem;" v-show="!isDisabled">
                        <a ref="reportLink" href="#" :download="$t(`report.types.${report.type}`)" class="no-print" @click="getFile()"><download-icon title="" />&nbsp;{{ $t('general.download') }}</a>
                    </div>
                    <z-report-details v-if="report.type === 'REPORT_Z'" :report="report" />
                    <x-report-details v-if="report.type === 'REPORT_X'" :report="report" />
                    <fiscal-period-report-details v-if="report.type === 'FISCAL_PERIOD_REPORT' || report.type === 'FISCAL_PERIOD_REPORT_V2'" :report="report" />
                    <cashier-report-details v-if="report.type === 'CASHIER_REPORT'" :report="report" />
                    <section-report-details v-if="report.type === 'SECTION_REPORT'" :report="report" />
                </b-card>
                <b-card v-if="isReportInfo" class="mt-3">
                    <qriously class="row justify-content-center" :value="reportInfo.sign" :size="100" foreground="#474747" />
                </b-card>
            </div>
        </template>
    </page-base>
</template>

<script>
/* eslint-disable */
import AppData from '@/utils/appdata';
import { normalizeReports } from '@/utils/utils';
import ZReportHeading from '@/components/report/ZReportHeading.vue'
import ZReportDetails from '@/components/report/ZReportDetails.vue'
import XReportDetails from '@/components/report/XReportDetails.vue'
import FiscalPeriodReportHeading from '@/components/report/FiscalPeriodReportHeading.vue'
import FiscalPeriodReportDetails from '@/components/report/FiscalPeriodReportDetails.vue'
import CashierReportHeading from '@/components/report/CashierReportHeading.vue'
import CashierReportDetails from '@/components/report/CashierReportDetails.vue'
import SectionReportDetails from '@/components/report/SectionReportDetails.vue'

export default {
    name: 'ReportDetails',
    mixins: [ AppData ],
    components: {
        ZReportHeading,
        ZReportDetails,
        XReportDetails,
        FiscalPeriodReportHeading,
        FiscalPeriodReportDetails,
        CashierReportHeading,
        CashierReportDetails,
        SectionReportDetails
    },
    mounted () {
        this.getCurrentTaxpayer()
        this.fetchData()
        this.getReportInfo()
    },
    data () {
        return {
            report: {},
            reportInfo: {},
            downloadUrl: ''
        }
    },
    computed: {
        isReportInfo: function () {
            return Object.keys(this.reportInfo).length > 0
        },
        reportName: function () {
            return this.isReportInfo ? `${this.$t(`report.types.${this.report.type || 'default'}`)} ${this.report.creationDate}` : ''
        },
        breadcrumbs: function () {
            var breadcrumbs = []
            this.$route.meta.breadcrumbs.forEach(element => {
                breadcrumbs.push({ text: this.$t(element.text), to: element.to })
            })
            breadcrumbs.push({ text: this.$t(`report.types.${this.report.type || 'default'}`), active: true })
            return breadcrumbs
        }
    },
    methods: {
        getReportInfo() {
            const data = {
                id: this.$route.params.id, 
                dealerId: this.currentTaxpayer 
                    ? this.currentTaxpayer.id 
                    : this.$route.params.dealerId
            };

            const onSuccess = response => {
                const reports = normalizeReports(response);

                if (reports.length !== 1) {
                    this.$router.push('/error/404');

                    console.error('Get report by id must be returns one item');

                    return;
                }

                if (reports[0] != null)
                    this.reportInfo = reports[0];
            };

            this.$request.sendRequest(
                this,
                this.$appConfig.apiUrls.report.getAll,
                data,
                onSuccess,
                this.displayAlert);
        },
        fetchData() {
            this.$request.sendRequest(
                this, 
                this.$appConfig.apiUrls.report.get,
                { id: this.$route.params.id }, 
                result => this.report = JSON.parse(result || {}),
                this.displayAlert);
        },
        getFile: function () {
            if (this.isDisabled) {
                event.preventDefault()
            } else if (this.downloadUrl === '') {
                this.$request.sendRequest(
                    this, 
                    this.$appConfig.apiUrls.report.getFile, 
                    { reportId: this.$route.params.id },
                    result => {
                        this.downloadUrl = result
                    }, this.displayAlert)
                event.preventDefault()
            }
        }
    },
    watch: {
        downloadUrl: function (newVal) {
            this.$refs.reportLink.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;base64,${newVal}`
            this.$refs.reportLink.click()
        }
    }
}
</script>
